<template>
  <div id="adminCrmCategories">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ crm }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">Categoria</router-link>
      </li>
    </ol>
     <div class="container-fluid card-title-admin"> 
        <div class="row">
          <div class="col-6 align-self-center">
            <h1>Categoria</h1>
          </div>
          <div class="col-6 text-right align-self-center" v-if="rowIdSelected > 0 || checkInsert">
            <label class="label-name" style="margin-bottom: 0px" v-if="!checkInsert">Online</label>
            <label
              class="switch switch-pill switch-primary"
              style="margin-left: 5px;margin-right:20px; vertical-align: bottom"
              v-if="!checkInsert"
            >
              <input
                type="checkbox"
                class="switch-input"
                id="idAssociationCodeImage"
                :checked="checkOnlineCategories"
                @change="onChangeCheckOnlineCategories"
              />
              <span class="switch-slider" data-on data-off></span>
            </label>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="confirmCancelNewCategories"
            ><i class="fa fa-chevron-left"></i>&nbsp;Indietro</button>
            <button
              type="button"
              class="btn btn-success"
              @click="confirmSaveNewCategories"
            ><i class="fa fa-floppy-o"></i>&nbsp;{{ save }}</button>
          </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content noborder">
          <div class="tab-pane active" id="tabTable" role="tabpanel" style="margin-top: -8px;">
            <div class="row align-btns" style="width:85%;">           
              <div class="col-lg-12">
                <button
                  id="btnAdd"
                  type="button"
                  class="btn btn-primary"
                  @click="onNewCategories"
                >
                  <i class="fa fa-plus"></i>
                  <span>{{ add }}</span>
                </button>
                <button
                  id="btnSave"
                  type="button"
                  class="btn btn-success"
                  @click="confirmSaveCategories"
                  :disabled="disableButton"
                >
                  <i class="fa fa-floppy-o"></i>
                  <span>{{ save }}</span>
                </button>
                <button
                  id="btnDelete"
                  type="button"
                  class="btn btn-danger"
                  @click="confirmDeleteCategories"
                  :disabled="disableButton"
                >
                  <i class="fa fa-trash trashtable"></i>
                  <span>{{ del }}</span>
                </button>
              </div>
            </div>     
            <div class="row">
              <div class="col-sm-12">
                <bootstrapTable
                  :configurations="tableConfiguration"
                  :datas="tableData"
                  id="tableCategories"
                  :onCheck="onTableCheckCategories"
                  :onCheckAll="onTableCheckCategories"
                  :onUncheck="onTableCheckCategories"
                  :onUncheckAll="onTableCheckCategories"
                  ref="tableCategories"
                  :results="tableResult"
                ></bootstrapTable>
              </div>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabDetail" role="tabpanel">
            <!--div class="card-header">
              <div class="row">
                <div class="col-sm-12 col-md-8 text-left">
                  <h5>{{newTitleCategory}}</h5>
                </div>
                <div class="col-sm-12 col-md-4 text-right">
                  <select2
                  id="select_AdminPagesView_IdLanguage"
                  ref="select_AdminPagesView_IdLanguage"
                  class="form-control nopadding"
                  style="width:75%"
                  :filterable="false"
                  service="languages"
                  v-model="
                  pageValueSelected.languagePageSetting.idLanguage
                  "
                  :default="defaultLanguageOptions"
                  :change="languageChange"                
                  />
                  <span>{{ language }}</span>
                </div>
              </div>
            </div-->
            <div class="">
              <div class="row">
                <div class="col-12">
                  <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                      <button
                        id="tabAdminCategoriesGeneralButton"
                        class="nav-link active"
                        type="button"
                        data-toggle="tab"
                        href="#tabAdminCategoriesGeneral"
                        role="tab"
                        aria-controls="tabAdminCategoriesGeneral"
                        v-on:click="onTabAdminCategoriesGeneral"  
                      >
                        <span>Dati</span>
                      </button>
                    </li>
                    <li class="nav-item" v-if="rowIdSelected>0">
                      <button
                        id="tabAdminCategoriesAttributeButton"
                        type="button"
                        class="nav-link"
                        data-toggle="tab"
                        href="#tabAdminCategoriesAttribute"
                        role="tab"
                        aria-controls="tabAdminCategoriesAttribute"  
                        v-on:click="onTabAdminCategoriesAttribute"          
                      >
                        <span>Categoria Padre</span>
                      </button>
                    </li>
                    
                    <li class="nav-item" v-if="rowIdSelected>0">
                      <button
                        id="tabAdminCategoriesImagesButton"
                        type="button"
                        class="nav-link"
                        data-toggle="tab"
                        href="#tabAdminCategoriesImages"
                        role="tab"
                        aria-controls="tabAdminCategoriesImages"  
                        v-on:click="onTabAdminCategoriesImages"          
                      >
                        <span>Immagini</span>
                      </button>
                    </li>
                    <li class="nav-item" v-if="rowIdSelected>0">
                      <button
                        id="tabAdminCategoriesTranslateButton"
                        type="button"
                        class="nav-link"
                        data-toggle="tab"
                        href="#tabAdminCategoriesTranslate"
                        role="tab"
                        aria-controls="tabAdminCategoriesTranslate"  
                        v-on:click="onTabAdminCategoriesTranslate"          
                      >
                        <span>Traduzioni</span>
                      </button>
                    </li>
                  </ul>
                
                  <div class="tab-content">
                    <div class="tab-pane active" id="tabAdminCategoriesGeneral" role="tabpanel" style="padding-left: 30px;padding-right: 30px;">
                      <div class="row">
                       <div v-if="rowIdSelected > 0">
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Modifica</h1>
                      </div>
                      <div v-else>
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Aggiungi</h1>
                      </div>
                        <pageDetail
                          functions="adminCrmCategories"
                          :configurations="detailConfiguration"
                          :jsonValue="detailData"
                        ></pageDetail>
                      </div>
                    </div>
                    <div class="tab-pane" id="tabDetailAttributeCategories" role="tabpanel" style="padding-left: 30px;padding-right: 30px;">
                      <div class="row">
                        <div class="col-sm-12 col-md-4" style="background: #fafafa; padding-top: 15px" >
                          <treeCategories :listCategories="listTreeCategories" ></treeCategories>
                        </div>
                        <div class="col-sm-12 col-md-8">
                          <div
                            class="listDetailCategories"
                            v-for="detailListCategories in arrayListCategoriesDetail"
                            v-bind:key="detailListCategories.id"
                          >
                            <div class="row">
                              <div class="col-4 align-self-center">
                                <label>{{
                                  detailListCategories.descriptionCategory
                                }}</label>
                              </div>
                              <div class="col-2 align-self-center">
                                <label>Ordinamento</label>
                                <input
                                  class="form-control"
                                  type="number"
                                  @change="
                                    updateOrderCategoryItem(
                                      detailListCategories.id
                                    )
                                  "
                                  :id="'inputOrder' + detailListCategories.id"
                                  :value="detailListCategories.order"
                                  :name="'inputOrder' + detailListCategories.id"
                                />
                              </div>
                              <div class="col-6 text-center align-self-center">
                                <label
                                  >{{
                                    detailListCategories.descriptionPrecItem
                                  }}
                                  ({{
                                    detailListCategories.orderPrecItem
                                  }})</label
                                >
                                <h5>
                                  {{ detailListCategories.descriptionItem }}
                                </h5>
                                <label
                                  >{{
                                    detailListCategories.descriptionPostItem
                                  }}
                                  ({{
                                    detailListCategories.orderPostItem
                                  }})</label
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>                     
                    </div>
                    <!-- TAB IMAGES -->
                    <div class="tab-pane" id="tabDetailAttributeImages" role="tabpanel" style="padding-left: 30px;padding-right: 30px;">
                        <!--<pageDetail
                          functions="adminCrmCategoriesImages"
                          :configurations="detailImagesConfiguration"
                          :jsonValue="detailData"
                        ></pageDetail>-->

                      <div
                        class="row div-row-img-item"
                        style="border-bottom: 4px dashed #ededed"
                        v-if="!checkAssociationCodeImage"
                      >
                        <div class="col-9">
                          <div class="row div-row-img-item">
                            <div class="col-5 align-self-center">
                              <label>Immagine Principale</label><br />
                              <button
                                class="btn btn-primary"
                                @click="selectImageExist(itemImages.id, true)"
                              >
                                SELEZIONA
                              </button>
                              <label class="label-name">{{
                                itemImages.imgName
                              }}</label>
                            </div>
                            <div class="col-2 align-self-center">
                              <label>Anteprima</label><br />
                              <a class="img" :href="itemImages.img"><img :src="itemImages.img" /></a>
                            </div>
                            <div class="col-4 align-self-center">
                              <label style="margin-top: 15px;" v-if="itemImages.weight != '0 bytes'">
                                <i class="fa fa-balance-scale fa-stack" aria-hidden="true"></i> {{ itemImages.weight }}
                              </label><br>
                              <label v-if="itemImages.width>0 || itemImages.width!=0">
                                <i class="fa fa-arrows-alt fa-stack" aria-hidden="true"></i>{{ itemImages.width }} x {{ itemImages.height }} pixel
                              </label>
                            </div>
                            <div class="col-1 align-self-center">
                              <i
                                class="fa fa-trash btn btn-danger"
                                style="color:#fff;"
                                @click="deleteImage(true, itemImages.id)"
                              ></i>
                            </div>
                          </div>
                        </div>
                        <div class="col-3 align-self-center">
                          <label
                            for="imgPrincipalCategories"
                            class="custom-file-upload"
                            v-cloak
                            @drop.prevent="onChangeImagePrincipalCategories"
                            @dragover.prevent
                          >
                            SFOGLIA / UPLOAD AREA
                          </label>
                          <input
                            type="file"
                            id="imgPrincipalCategories"
                            name="imgPrincipalCategories"
                            @change="onChangeImagePrincipalCategories"
                          />
                        </div>
                      </div>
                      <div
                        class="row div-row-img-item"
                        style="border-bottom: 4px dashed #ededed"
                        v-if="!checkAssociationCodeImage"
                      >
                        <div class="col-9">
                          <div class="row div-row-img-item">
                            <div class="col-5 align-self-center">
                              <label>Immagine Banner</label><br />
                              <button
                                class="btn btn-primary"
                                @click="selectImageExist(itemImages.id, false)"
                              >
                                SELEZIONA
                              </button>
                              <label class="label-name">{{
                                itemImages.imgNameBanner
                              }}</label>
                            </div>
                            <div class="col-2 align-self-center">
                              <label>Anteprima</label><br />
                              <a class="img" :href="itemImages.imgBanner"><img :src="itemImages.imgBanner" /></a>
                            </div>
                            <div class="col-4 align-self-center">
                              <label style="margin-top: 15px;" v-if="itemImages.weightBanner != '0 bytes' ">
                                <i class="fa fa-balance-scale fa-stack" aria-hidden="true"></i> {{ itemImages.weightBanner }}
                              </label><br>
                              <label v-if="itemImages.widthBanner>0 || itemImages.widthBanner!=0">
                                <i class="fa fa-arrows-alt fa-stack" aria-hidden="true"></i>{{ itemImages.widthBanner }} x {{ itemImages.heightBanner }} pixel
                              </label>
                            </div>
                            <div class="col-1 align-self-center">
                              <i
                                class="fa fa-trash btn btn-danger"
                                style="color:#fff;"
                                @click="deleteImage(true, itemImages.id)"
                              ></i>
                            </div>
                          </div>
                        </div>
                        <div class="col-3 align-self-center">
                          <label
                            for="imgBanner"
                            class="custom-file-upload"
                            v-cloak
                            @drop.prevent="onChangeImageBanner"
                            @dragover.prevent
                          >
                            SFOGLIA / UPLOAD AREA
                          </label>
                          <input
                            type="file"
                            id="imgBanner"
                            name="imgBanner"
                            @change="onChangeImageBanner"
                          />
                        </div>
                      </div>
                    </div>
                    <!-- old modal image 
                    <div
                    class="modal fade bd-example-modal-lg"
                    id="modalImageExistFolder"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="myLargeModalLabel"
                    aria-hidden="true"
                  >
                      <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                          <div class="row">
                            <div
                              class="col-4 text-center"
                              v-for="arrayAllImagesExistFolders in arrayAllImagesExistFolder"
                              v-bind:key="arrayAllImagesExistFolders.id"
                              @click="
                                selectReplaceImageExist(
                                  arrayAllImagesExistFolders.idImgAgg,
                                  arrayAllImagesExistFolders.imgName
                                )
                              "
                            >
                              <div class="contPreviewImageExistFolder">
                                <img
                                  :src="arrayAllImagesExistFolders.img"
                                  class="previewImageExistFolder"
                                /><br />
                                <div class="div-row-img-item">
                                  <label class="label-name">{{
                                    arrayAllImagesExistFolders.imgName
                                  }}</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    end old modal image -->
                    <!-- modal immagini -->
                    <div
                      class="modal"
                      id="modalImageExistFolder"
                      tabindex="-1"
                      role="dialog"
                      aria-labelledby="myModalLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialo popup" role="document">
                        <div class="modal-content modal">
                          <div class="modal-header text-center">
                            

                            <div class="row" style="width:100%;">
                              <div class="col-4 text-left"> 
                                <h2 style="color:#303C53;font-weight:bold;text-transform:uppercase;">Gestione immagini</h2>
                              </div>
                              <div class="col-2 text-right">
                              <select class="form-control" id="month" name="month" @change="Search()">
                                <option value="">Mese</option>
                                <option value="01">Gennaio</option>
                                <option value="02">Febbraio</option>
                                <option value="03">Marzo</option>
                                <option value="04">Aprile</option>
                                <option value="05">Maggio</option>
                                <option value="06">Giugno</option>
                                <option value="07">Luglio</option>
                                <option value="08">Agosto</option>
                                <option value="09">Settembre</option>
                                <option value="10">Ottobre</option>
                                <option value="11">Novembre</option>
                                <option value="12">Dicembre</option>
                              </select>
                            </div>
                            <div class="col-2 text-right">
                              <select class="form-control" id="year" name="year" @change="Search()">
                                <option value="">Anno</option>
                                <option value="2025">2025</option>
                                <option value="2024">2024</option>
                                <option value="2023">2023</option>
                                <option value="2022">2022</option>
                                <option value="2021">2021</option>
                                <option value="2020">2020</option>
                                <option value="2019">2019</option>
                                <option value="2018">2018</option>
                                <option value="2017">2017</option>
                                <option value="2016">2016</option>
                                <option value="2015">2015</option>
                                <option value="2014">2014</option>
                                <option value="2013">2013</option>
                                <option value="2012">2012</option>
                                <option value="2011">2011</option>
                                <option value="2010">2010</option>
                              </select>
                            </div>
                              <div class="col-4"> 
                                <input type="text" class="form-control" id="search" required="required" name="search" placeholder="Cerca" @keyup="Search()"/> 
                              </div>
                            </div>

                            <button
                              type="button"
                              class="close"
                              data-dismiss="modal"
                              aria-label="Close"

                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body mx-3">
                            <div class="md-form mb-5">
                              <div
                                class="row">
                                <ul class="list-group" id="ul-image" @scroll="handleScroll">
                                <li class="listLi" v-for="arrayAllImagesExistFolders in arrayAllImagesExistFolder" v-bind:key="arrayAllImagesExistFolders.id" @click="
                                  selectReplaceImageExist(
                                  idImageSelectedToReplaceImage,
                                  arrayAllImagesExistFolders.imgName)" >
                                  <div class="list-group-item" :style="'cursor:pointer;position: relative;min-width:110px;min-height:110px;min-width:110px;max-width:110px;background-size:cover;background-image:url(\'' + arrayAllImagesExistFolders.img + '\')'">
                                    <div v-if="arrayAllImagesExistFolders.ext!=''" class="div-extension-img">
                                      <label>{{ arrayAllImagesExistFolders.ext }}</label>
                                    </div>
                                    <label class="labelListImage">{{ arrayAllImagesExistFolders.imgName }}</label>
                                  </div>
                                  </li> 
                              </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- end modal immagini -->
                    <!-- TAB IMAGES -->


                    <div class="tab-pane" id="tabAdminCategoriesFather" role="tabpanel" style="padding-left: 30px;padding-right: 30px;">
                      <div class="row">
                        <div class="col-12">
                          
                        </div>
                      </div>
                    </div>
                    <!-- TAB TRADUZIONI -->
                    <div class="tab-pane" id="tabAdminCategoriesTranslate" role="tabpanel" style="padding-left: 30px;padding-right: 30px;">
                      <div class="col-10" v-if="categoriesLanguages.length > 0">
                        <div class="row">
                          <div class="col-2">
                            <b></b>
                          </div>
                          <div class="col-3">
                            <label>Lingua</label>
                          </div>
                          <div class="col-3">
                            <label>Descrizione</label>
                          </div>
                          <div class="col-4">
                            <label>Caratteristica</label>
                          </div>
                        </div>
                      </div>
                      <div 
                        v-for="itemLanguage in categoriesLanguages"
                        v-bind:key="itemLanguage.id"
                      >
                        <div class="col-10">
                          <div class="row add div-row-translation">
                            <div class="col-2 text-left align-self-center">
                              <button
                                type="button"
                                class="btn btn-success"
                                @click="
                                  executeOpenTranslationsLanguage(itemLanguage.id)
                                "
                              >
                                <i class="fa fa-pencil"></i>
                              </button>

                              <button
                                type="button"
                                class="btn btn-danger"
                                @click="
                                  executeCancelTranslationsLanguage(
                                    itemLanguage.id
                                  )
                                "
                              >
                                <i class="fa fa-trash" style="color: #fff"></i>
                              </button>
                            </div>
                            <div class="col-3 align-self-center">
                              <span
                                class="col- col-form-label nopadding"
                                :for="itemLanguage.language_id"
                                >{{ itemLanguage.language_id }}</span
                              >
                            </div>

                            <div class="col-3 align-self-center">
                              <div class="translate-characteristic">
                                <span
                                  class="col- col-form-label nopadding"
                                  :for="itemLanguage.description"
                                  >{{ itemLanguage.description }}</span
                                >
                              </div>
                            </div>
                            <div class="col-4 align-self-center">
                              <div class="translate-characteristic">
                                <span
                                  class="col- col-form-label nopadding"
                                  :for="itemLanguage.meta_tag_characteristic"
                                  >{{
                                    itemLanguage.meta_tag_characteristic
                                  }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 text-right">
                          <button
                            v-if="!noMoreTranslate"
                            type="button"
                            class="btn btn-primary button-add"
                            @click="confirmSaveNewTranslate()"
                          ><i class="fa fa-plus"></i>&nbsp; 
                            Aggiungi
                          </button>
                        </div>
                      </div>
                    </div>
                    <!--Modal esegui modifica traduzioni DetailTranslation-->
                    <div
                      class="modal"
                      id="modalExecuteTranslateItem"
                      tabindex="-1"
                      role="dialog"
                      aria-labelledby="myModalLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content padding">
                          <div class="modal-header text-center">
                            <h4 class="modal-title w-100 font-weight-bold">
                              Modifica Traduzione Categoria
                            </h4>
                            <button
                              type="button"
                              class="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body mx-12">
                            <div class="md-form mb-12">
                              <div class="row">
                                <div class="col-12">
                                  <div
                                    class="col-12 text-right"
                                    style="padding-top: 1rem"
                                  >
                                    <button
                                      type="button"
                                      class="btn btn-primary"
                                      @click="
                                        executeCopyDefaultTranslate(
                                          resultTranslatePopups.id,
                                          resultTranslatePopups.idItem,
                                          resultTranslatePopups.language_id
                                        )
                                      "
                                    ><i class="fa fa-clone"></i>
                                      COPIA DA LINGUA DI DEFAULT
                                    </button>
                                  </div>
                                  <pageDetail
                                    functions="adminCrmItemsTranslation"
                                    :configurations="
                                      detailTranslationConfiguration
                                    "
                                    :jsonValue="resultTranslatePopups"
                                  ></pageDetail>
                                  <div
                                    class="col-12 text-right"
                                    style="padding-top: 3rem"
                                  >
                                    <button
                                      type="button"
                                      class="btn btn-success"
                                      @click="
                                        confirmSaveTranslate(
                                          resultTranslatePopups.id,
                                          resultTranslatePopups.idItem,
                                          resultTranslatePopups.language_id,
                                          resultTranslatePopups.description,
                                          resultTranslatePopups.link,
                                          resultTranslatePopups.meta_tag_characteristic
                                        )
                                      "
                                    >	<i class="fa fa-floppy-o"></i>
                                      SALVA
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- end modal traduzioni -->
                    <!--  END TAB TRADUZIONI  -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";
import Select2 from "@/components/Select2.vue";
import TreeCategories from "@/components/TreeCategories.vue";

export default {
  name: "adminCrmCategories",
  components: {
    BootstrapTable,
    Select2,
    PageDetail,
    TreeCategories
  },
  data: function() {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      language: dictionaryHelpers.getDictionary("Language"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      crm: dictionaryHelpers.getDictionary("CRM"),
      Categories: dictionaryHelpers.getDictionary("Categories"),
      del: dictionaryHelpers.getDictionary("Delete"),
      deleteCompleted: dictionaryHelpers.getDictionary("DeleteCompleted"),
      detailConfiguration: [],
      detailAttributeConfiguration:[],
      detailImagesConfiguration:[],
      detailTranslationConfiguration:[],
      detailData: {},
      languages: 0,
      disableButton: true,
      insertCompleted: dictionaryHelpers.getDictionary("InsertCompleted"),
      newCategories: dictionaryHelpers.getDictionary("newCategories"),
      newTitleCategory: dictionaryHelpers.getDictionary("newTitleCategory"),
      openDetail: dictionaryHelpers.getDictionary("OpenDetail"),
      save: dictionaryHelpers.getDictionary("Save"),
      defaultLanguageOptions: [],
      pageValueSelected: {
      id: 0,
      languagePageSetting: { content: null }
      },
      tableConfiguration: [],
      tableCustomerResult: [],
      tableData: [],
      tableResult: [],
      titleDetail: null,
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      url: window.location.pathname,
      rowIdSelected: 0,
      rowsSelected: 0,
      checkOnlineCategories: false,
      checkInsert: false,
      listTreeCategories: [],
      arrayListCategoriesDetail: [],
      checkAssociationCodeImage: false,
      itemImages: [],
      categoriesLanguages: [],
      arrayAllImagesExistFolder: [],
      selectedChangePrincipalImage: false,
      resultTranslatePopups: {},
      noMoreTranslate: false,
      scriptGallery: false,
      pageImage: 1,
      idImageSelectedToReplaceImage: 0
    };
  },
  created() {
    var adminCrmCategories = this;
    spinnerHelpers.show();
    
    this.languages = storageData.sIdLanguage();

    adminCrmCategories.defaultLanguageOptions = {
      id: storageData.sIdLanguage(),
      text: storageData.sDescriptionLanguage()
    };

    adminConfigurationServices.getFunctionality(function(result) {


      adminCrmCategories.tableConfiguration = result.data.tablesConfigurations[0].tablesConfigurations;
      adminCrmCategories.detailConfiguration = result.data.tabsConfigurations[0].pageConfigurations;
      adminCrmCategories.detailImagesConfiguration = result.data.tabsConfigurations[1].pageConfigurations;
      adminCrmCategories.detailAttributeConfiguration = result.data.tabsConfigurations[2].pageConfigurations;
      adminCrmCategories.detailTranslationConfiguration = result.data.tabsConfigurations[3].pageConfigurations;

      adminCrmCategories.loadTable();
    });
  },
  methods: {
    handleScroll(){
      if($('#ul-image').scrollTop() + $('#ul-image').innerHeight() >= $('#ul-image')[0].scrollHeight) {
        this.pageImage = this.pageImage + 1;
        this.selectImageExist(this.idImageSelectedToReplaceImage, this.selectedChangePrincipalImage);
      }
    },
    Search() { 
      var adminSettingNews = this;
      adminCrmItems.pageImage = 1;
      adminSettingNews.selectImageExist(adminCrmItems.idImageSelectedToReplaceImage, adminCrmItems.selectedChangePrincipalImage);
    },
    onTabAdminCategoriesGeneral(){
      $('#tabDetailAttributeCategories').removeClass("active");
      $('#tabDetailAttributeImages').removeClass("active");
      $('#tabAdminCategoriesGeneral').addClass("active");
      $('#tabAdminCategoriesFather').removeClass("active");
      $('#tabAdminCategoriesTranslate').removeClass("active");
    },
    onTabAdminCategoriesAttribute(){
      $('#tabAdminCategoriesGeneral').removeClass("active");
      $('#tabDetailAttributeImages').removeClass("active");
      $('#tabDetailAttributeCategories').addClass("active");
      $('#tabAdminCategoriesFather').removeClass("active");
      $('#tabAdminCategoriesTranslate').removeClass("active");
      this.loadListCategories();
      this.loadDetailListCategories();
    },
    onTabAdminCategoriesImages(){
      $('#tabAdminCategoriesGeneral').removeClass("active");
      $('#tabDetailAttributeImages').addClass("active");
      $('#tabDetailAttributeCategories').removeClass("active");
      $('#tabAdminCategoriesFather').removeClass("active");
      $('#tabAdminCategoriesTranslate').removeClass("active");
      this.loadItemImages();
    },
    onTabAdminCategoriesFather(){
      $('#tabAdminCategoriesGeneral').removeClass("active");
      $('#tabAdminCategoriesFather').addClass("active");
      $('#tabDetailAttributeImages').removeClass("active");
      $('#tabDetailAttributeCategories').removeClass("active");
      $('#tabAdminCategoriesTranslate').removeClass("active");
    },
    onTabAdminCategoriesTranslate(){
      $('#tabAdminCategoriesGeneral').removeClass("active");
      $('#tabAdminCategoriesFather').removeClass("active");
      $('#tabDetailAttributeImages').removeClass("active");
      $('#tabDetailAttributeCategories').removeClass("active");
      $('#tabAdminCategoriesTranslate').addClass("active");
      this.loadTranslation();
    },
    loadTable(ln) {
      var adminCrmCategories = this;
      if(!functionHelpers.isValued(ln)){
        ln = storageData.sIdLanguage();
      }else{
        ln = this.languages;
      }
      categoriesServices.getAll(ln,function(result) {
        adminCrmCategories.tableData = result.data;
        adminCrmCategories.rowIdSelected = '';
        adminCrmCategories.checkInsert = false;

        var url = new URL(window.location.href);
        var c = url.searchParams.get("id");
        if(c != '' && c != undefined && c != null){
          adminCrmCategories.executeOpenDetail(c);
        }
        spinnerHelpers.hide();
      });
    },
    languageChange(value) {
      spinnerHelpers.show();
      var adminCrmCategories = this;
      this.languages = value;
      adminCrmCategories.loadTable(value);
      spinnerHelpers.hide();
    },
    CategoriesFatherFormatter(value, row, index, field) {
      var adminCrmCategories = this;
      var html = '<div class="container-fluid" style="min-width:80px;"><div class="row">';
      var classLevel = 'level-0';

      switch (row.level) {
        case 0:
          classLevel = 'level-0';
          break;
        case 1:
          classLevel = 'level-1';
          break;
        case 2:
          classLevel = 'level-2';
          break;
        case 3:
          classLevel = 'level-3';
          break;
        case 4:
          classLevel = 'level-4';
          break;
        case 5:
          classLevel = 'level-5';
          break;
        default:
          classLevel = 'level-0';
          
      }
      html += '<div class="' + classLevel + '"></div>' + row.description;
      html += "</div></div>";
      return html;
    },
    OrderCategoriesFormatter(value, row, index, field) {
      var adminCrmCategories = this;
      var html = '<div class="container-fluid" style="min-width:80px;"><div class="row">';
      html += '<i class="fa fa-chevron-up" style="cursor: pointer;margin-top: 8px;font-size: 18px;margin-right: 5px;background: #20A8D8;padding: 5px;border-radius: 50%;color: #fff;" onclick="adminCrmCategories.__vue__.changeOrderCategoryFatherUp(' + row.category_father_id + ')"></i>';
      html += '<input class="form-control " type="hidden" min="0" style="max-width:65px;" value="' + row.order + '" id="order-table-input-' + row.category_father_id + '" onchange="adminCrmCategories.__vue__.changeOrderCategoryFather(' + row.category_father_id + ')">';
      html += '<i class="fa fa-chevron-down" style="cursor: pointer;margin-top: 8px;font-size: 18px;margin-left: 5px;background: #20A8D8;padding: 5px;border-radius: 50%;color: #fff;" onclick="adminCrmCategories.__vue__.changeOrderCategoryFatherDown(' + row.category_father_id + ')"></i>';
      html += "</div></div>";
      return html;
    },
    CategoriesFormatter(value, row, index, field) {
      var adminCrmCategories = this;
      var html =
      '<div class="container-fluid" style="min-width:80px;"><div class="row">';
      html +=
         '<button class="btn btn-success" onclick="adminCrmCategories.__vue__.executeOpenDetail(' +
        row.id +
        ')"><i class="fa fa-pencil" title="' +
        this.openDetail +
        '" /></button>';
         html +=
        '<button class="btn btn-info" onclick="adminCrmCategories.__vue__.clone(' +
        row.id +
        ')"><i class="fa fa-files-o" style="color:#fff!important;"/></button>';
          html +=
         '<button class="btn btn-danger" onclick="adminCrmCategories.__vue__.delete(' +
        row.id +
        ')"><i class="fa fa-trash"/></button>';


      if (functionHelpers.isValued(this.tableResult)) {
        $.each(this.tableResult, function(i, result) {
          if (result.id == row.id) {
            if (result.success) {
              html +=
                '<div class="col-1"><i class="fa fa-check text-success" title="';
              if (functionHelpers.isValued(result.message)) {
                html += result.message;
              } else {
                html += adminCrmCategories.updateCompleted;
              }
              html += '" /></div>';
            } else {
              html +=
                '<div class="col-1"><i class="fa fa-exclamation-triangle text-danger" title="' +
                result.message +
                '" /></div>';
            }
            return;
          }
        });
      }
      html += "</div></div>";
      return html;
    },

onKeyUpTitleItems() {
    var adminCrmCategories = this;
    var SeotitleToTitles= $("#meta_tag_title").val();
    
   if (SeotitleToTitles == '' || SeotitleToTitles == null || SeotitleToTitles == 'null' || SeotitleToTitles == 0) {
        var d = ((96 * 10)/100) + "%";
        $('#meta_tag_title_feedback').remove();
        $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(9.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
  }else{
   if (SeotitleToTitles.length >= 0 && SeotitleToTitles.length <= 30){
        var d = ((96 * SeotitleToTitles.length)/30) + "%";
        $('#meta_tag_title_feedback').remove();
        $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
      }
     if (SeotitleToTitles.length >= 31 && SeotitleToTitles.length <= 60){
        var d = ((96 * SeotitleToTitles.length)/60) + "%";
        $('#meta_tag_title_feedback').remove();
        $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: 15px;left: 13px;"></div>')
      }
      if (SeotitleToTitles.length >= 61 && SeotitleToTitles.length <= 1000){
        var d = ((96 * SeotitleToTitles.length)/1000) + "%";
        $('#meta_tag_title_feedback').remove();
        $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: 15px;left: 13px;"></div>')
      }
    }
 },

    onKeyUpDescriptionItems() {
    var adminCrmCategories = this;
    var SeoDesciptionToTitles= $("#meta_tag_description").val();

    if (SeoDesciptionToTitles == '' || SeoDesciptionToTitles == null || SeoDesciptionToTitles == 'null' || SeoDesciptionToTitles == 0) {
      var d = ((96 * 10)/100) + "%";
          $('#meta_tag_description_feedback').remove();
          $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(4.7%); height: 5px;background: #FF0000;position: relative;bottom: -105px;left: 13px;"></div>')
  }else{
    if (SeoDesciptionToTitles.length >= 0 && SeoDesciptionToTitles.length <= 70){
            var d = ((96 * SeoDesciptionToTitles.length)/70) + "%";
              $('#meta_tag_description_feedback').remove();
              $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: -105px;left: 13px;"></div>')
        }

        if (SeoDesciptionToTitles.length >= 71 && SeoDesciptionToTitles.length <= 155){
            var d = ((96 * SeoDesciptionToTitles.length)/155) + "%";
            $('#meta_tag_description_feedback').remove();
            $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: -105px;left: 13px;"></div>')
        }

        if (SeoDesciptionToTitles.length >= 156 && SeoDesciptionToTitles.length <= 2000){
            var d = ((96 * SeoDesciptionToTitles.length)/2000) + "%";
            $('#meta_tag_description_feedback').remove();
            $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: -105px;left: 13px;"></div>')
        }
      }
  },

changeMetaTagTitle() {
  var adminCrmCategories = this;
    var SeotitleToTitles= $("#meta_tag_title").val();

 if (SeotitleToTitles == '' || SeotitleToTitles == null || SeotitleToTitles == 'null' || SeotitleToTitles == 0) {
        var d = ((96 * 10)/100) + "%";
        $('#meta_tag_title_feedback').remove();
        $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(9.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
  }else{
   if (SeotitleToTitles.length >= 0 && SeotitleToTitles.length <= 30){
        var d = ((96 * SeotitleToTitles.length)/30) + "%";
        $('#meta_tag_title_feedback').remove();
        $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
      }
     if (SeotitleToTitles.length >= 31 && SeotitleToTitles.length <= 60){
        var d = ((96 * SeotitleToTitles.length)/60) + "%";
        $('#meta_tag_title_feedback').remove();
        $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: 15px;left: 13px;"></div>')
      }
      if (SeotitleToTitles.length >= 61 && SeotitleToTitles.length <= 1000){
        var d = ((96 * SeotitleToTitles.length)/1000) + "%";
        $('#meta_tag_title_feedback').remove();
        $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: 15px;left: 13px;"></div>')
      }
    }

  /*  if (SeotitleToTitles.length >= 0 && SeotitleToTitles.length <= 70){
        var d = ((87 * SeotitleToTitles.length)/70) + "%";
        $('#meta_tag_title_feedback').remove();
        $('#meta_tag_title').after('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: -43px;left: 13px;"></div>')
    }
    if (SeotitleToTitles.length >= 70 && SeotitleToTitles.length <= 155){
        var d = ((87 * SeotitleToTitles.length)/155) + "%";
        $('#meta_tag_title_feedback').remove();
        $('#meta_tag_title').after('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: -43px;left: 13px;"></div>')
    }
    if (SeotitleToTitles.length >= 155 && SeotitleToTitles.length <= 200){
        var d = ((87 * SeotitleToTitles.length)/200) + "%";
        $('#meta_tag_title_feedback').remove();
        $('#meta_tag_title').after('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: -43px;left: 13px;"></div>')
    }*/
},

changeMetaTagDescription() {
  var adminCrmCategories = this;
    var SeoDesciptionToTitles= $("#meta_tag_description").val();


   if (SeoDesciptionToTitles == '' || SeoDesciptionToTitles == null || SeoDesciptionToTitles == 'null' || SeoDesciptionToTitles == 0) {
      var d = ((96 * 10)/100) + "%";
          $('#meta_tag_description_feedback').remove();
          $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(4.7%); height: 5px;background: #FF0000;position: relative;bottom: -105px;left: 13px;"></div>')
  }else{
    if (SeoDesciptionToTitles.length >= 0 && SeoDesciptionToTitles.length <= 70){
            var d = ((96 * SeoDesciptionToTitles.length)/70) + "%";
              $('#meta_tag_description_feedback').remove();
              $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: -105px;left: 13px;"></div>')
        }

        if (SeoDesciptionToTitles.length >= 71 && SeoDesciptionToTitles.length <= 155){
            var d = ((96 * SeoDesciptionToTitles.length)/155) + "%";
            $('#meta_tag_description_feedback').remove();
            $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: -105px;left: 13px;"></div>')
        }

        if (SeoDesciptionToTitles.length >= 156 && SeoDesciptionToTitles.length <= 2000){
            var d = ((96 * SeoDesciptionToTitles.length)/2000) + "%";
            $('#meta_tag_description_feedback').remove();
            $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: -105px;left: 13px;"></div>')
        }
      }

  /*  if (SeoDesciptionToTitles.length >= 0 && SeoDesciptionToTitles.length <= 70){
        var d = ((87 * SeoDesciptionToTitles.length)/70) + "%";
        $('#meta_tag_description_feedback').remove();
        $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: -43px;left: 13px;"></div>')
    }
    if (SeoDesciptionToTitles.length >= 70 && SeoDesciptionToTitles.length <= 155){
        var d = ((87 * SeoDesciptionToTitles.length)/155) + "%";
        $('#meta_tag_description_feedback').remove();
        $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: -43px;left: 13px;"></div>')
    }
    if (SeoDesciptionToTitles.length >= 155 && SeoDesciptionToTitles.length <= 200){
        var d = ((87 * SeoDesciptionToTitles.length)/200) + "%";
        $('#meta_tag_description_feedback').remove();
        $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: -43px;left: 13px;"></div>')
    }*/
},

    OnlineCategoriesFormatter (value, row, index, field){    
      var adminCrmCategories = this;  
      var html = "";

      html += '<label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom">';
      
      if(row.online){
        html += '<input type="checkbox" class="switch-input" checked="checked" onclick="adminCrmCategories.__vue__.updateOnlineCategories(' + row.id + ')"/>';
      }else{
        html += '<input type="checkbox" class="switch-input" onclick="adminCrmCategories.__vue__.updateOnlineCategories(' + row.id + ')"/>';
      }
      html += '<span class="switch-slider" data-on data-off></span>';
      html += '</label>';

      return html;
    },
    changeOrderCategoryFatherUp(id){
      var adminCrmCategories = this;
      var ln = adminCrmCategories.languages;
      var order = parseInt($('#order-table-input-' + id).val()) - 10;

      if(order < 0){
        order = 0;
      }
      var data = {
        'id': id,
        'order': order
      }

      categoriesServices.updateOrderCategoriesTable(data, function (result) {
        notificationHelpers.success("Aggiornamento avvenuto correttamente");
        spinnerHelpers.show();
          if (!functionHelpers.isValued(ln)) {
            ln = storageData.sIdLanguage();
          }
          adminCrmCategories.loadTable(ln);
      });
    },
    changeOrderCategoryFather(id){
      var adminCrmCategories = this;
      var ln = adminCrmCategories.languages;
      var order = $('#order-table-input-' + id).val();

      if($('#order-table-input-' + id).val()<0){
        order = 0;
      }
      var data = {
        'id': id,
        'order': order
      }

      categoriesServices.updateOrderCategoriesTable(data, function (result) {
        notificationHelpers.success("Aggiornamento avvenuto correttamente");
        spinnerHelpers.show();
          if (!functionHelpers.isValued(ln)) {
            ln = storageData.sIdLanguage();
          }
          adminCrmCategories.loadTable(ln);
      });
    },
    changeOrderCategoryFatherDown(id){
      var adminCrmCategories = this;
      var ln = adminCrmCategories.languages;
      var order = parseInt($('#order-table-input-' + id).val()) + 10;

      var data = {
        'id': id,
        'order': order
      }

      categoriesServices.updateOrderCategoriesTable(data, function (result) {
        notificationHelpers.success("Aggiornamento avvenuto correttamente");
        spinnerHelpers.show();
          if (!functionHelpers.isValued(ln)) {
            ln = storageData.sIdLanguage();
          }
          adminCrmCategories.loadTable(ln);
      });
    },
    executeOpenDetail(id) {
      spinnerHelpers.show();
      var adminCrmCategories = this;
      this.rowIdSelected = id;
      this.titleDetail = this.customer;

      $.each(this.tableData, function(i, row) {
        if (adminCrmCategories.rowIdSelected == row.id) {
          adminCrmCategories.detailData = row;
          adminCrmCategories.checkOnlineCategories = adminCrmCategories.detailData.online;

  var SeotitleToTitles = row.meta_tag_title;
        if (SeotitleToTitles == '' || SeotitleToTitles == null || SeotitleToTitles == 'null' || SeotitleToTitles == 0) {
              var d = ((96 * 10)/100) + "%";
              $('#meta_tag_title_feedback').remove();
              $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(9.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
        }else{
        if (SeotitleToTitles.length >= 0 && SeotitleToTitles.length <= 30){
              var d = ((96 * SeotitleToTitles.length)/30) + "%";
              $('#meta_tag_title_feedback').remove();
              $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
            }
          if (SeotitleToTitles.length >= 31 && SeotitleToTitles.length <= 60){
              var d = ((96 * SeotitleToTitles.length)/60) + "%";
              $('#meta_tag_title_feedback').remove();
              $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: 15px;left: 13px;"></div>')
            }
            if (SeotitleToTitles.length >= 61 && SeotitleToTitles.length <= 1000){
              var d = ((96 * SeotitleToTitles.length)/1000) + "%";
              $('#meta_tag_title_feedback').remove();
              $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: 15px;left: 13px;"></div>')
            }
          } 
          
      var SeoDesciptionToTitles = row.meta_tag_description;
      if (SeoDesciptionToTitles == '' || SeoDesciptionToTitles == null || SeoDesciptionToTitles == 'null' || SeoDesciptionToTitles == 0) {
            var d = ((96 * 10)/100) + "%";
                $('#meta_tag_description_feedback').remove();
                $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(4.7%); height: 5px;background: #FF0000;position: relative;bottom: -105px;left: 13px;"></div>')
        }else{
          if (SeoDesciptionToTitles.length >= 0 && SeoDesciptionToTitles.length <= 70){
                  var d = ((96 * SeoDesciptionToTitles.length)/70) + "%";
                    $('#meta_tag_description_feedback').remove();
                    $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: -105px;left: 13px;"></div>')
              }

              if (SeoDesciptionToTitles.length >= 71 && SeoDesciptionToTitles.length <= 155){
                  var d = ((96 * SeoDesciptionToTitles.length)/155) + "%";
                  $('#meta_tag_description_feedback').remove();
                  $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: -105px;left: 13px;"></div>')
              }

              if (SeoDesciptionToTitles.length >= 156 && SeoDesciptionToTitles.length <= 2000){
                  var d = ((96 * SeoDesciptionToTitles.length)/2000) + "%";
                  $('#meta_tag_description_feedback').remove();
                  $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: -105px;left: 13px;"></div>')
              }
            }

      /*  var SeoMetaTagKeyword = row.meta_tag_keyword;
        if (SeoMetaTagKeyword == '' || SeoMetaTagKeyword == null || SeoMetaTagKeyword == 'null' || SeoMetaTagKeyword == 0) {
              var d = ((96 * 10)/100) + "%";
              $('#meta_tag_keyword_feedback').remove();
              $('#meta_tag_keyword').before('<div id="meta_tag_keyword_feedback" style="width: calc(9.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
        }else{
        if (SeoMetaTagKeyword.length >= 0 && SeoMetaTagKeyword.length <= 30){
              var d = ((96 * SeoMetaTagKeyword.length)/30) + "%";
              $('#meta_tag_keyword_feedback').remove();
              $('#meta_tag_keyword').before('<div id="meta_tag_keyword_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
            }
          if (SeoMetaTagKeyword.length >= 31 && SeoMetaTagKeyword.length <= 60){
              var d = ((96 * SeoMetaTagKeyword.length)/60) + "%";
              $('#meta_tag_keyword_feedback').remove();
              $('#meta_tag_keyword').before('<div id="meta_tag_keyword_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: 15px;left: 13px;"></div>')
            }
            if (SeoMetaTagKeyword.length >= 61 && SeoMetaTagKeyword.length <= 1000){
              var d = ((96 * SeoMetaTagKeyword.length)/1000) + "%";
              $('#meta_tag_keyword_feedback').remove();
              $('#meta_tag_keyword').before('<div id="meta_tag_keyword_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: 15px;left: 13px;"></div>')
            }
          } */

        }
      });

      $("#tabTable").removeClass("active");
      $('#tabDetailAttributeCategories').removeClass("active");
      $('#tabDetailAttributeImages').removeClass("active");
      $("#tabDetail").addClass("active");
      $('#tabAdminCategoriesGeneral').addClass("active");
      $('#tabDetailAttributeCategories').removeClass("active");
      $('#tabAdminCategoriesTranslate').removeClass("active");
      
      spinnerHelpers.hide();
    },

    clone(id) {
      var adminCrmCategories = this;
      var ln = adminCrmCategories.languages;
      spinnerHelpers.show();
      categoriesServices.clone(id, function() {
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("CloneCompleted")
        );
        
        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
        adminCrmCategories.loadTable(ln);
      });
    },


    delete(id) {
       if (confirm("Sei sicuro di voler eliminare?")) {
        this.executeDelete(id);
      }
    },

    executeDelete(id) {
      var adminCrmCategories = this;
      var ln = adminCrmCategories.languages;
      spinnerHelpers.show();
      categoriesServices.del(id, function() {
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("DeleteCompleted")
        );
        
        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
        adminCrmCategories.loadTable(ln);
        window.scrollTo(0, 0);
      });
    },

    onNewCategories() {
      spinnerHelpers.show();
      var adminCrmCategories = this;
      adminCrmCategories.detailData.characteristic = '';
      adminCrmCategories.detailData.categoryFather = '';
      adminCrmCategories.detailData.categoryTypeDescription = '';
      adminCrmCategories.detailData.category_father_id = '';
      adminCrmCategories.detailData.category_type_id = '';
      adminCrmCategories.detailData.code = '';
      adminCrmCategories.detailData.description = '';
      adminCrmCategories.detailData.id = '';
      adminCrmCategories.detailData.img = '';
      adminCrmCategories.detailData.link = '';
      adminCrmCategories.detailData.meta_tag_description = '';
      adminCrmCategories.detailData.meta_tag_keyword = '';
      adminCrmCategories.detailData.meta_tag_title = '';
      adminCrmCategories.detailData.order = '';
      adminCrmCategories.detailData.urlTable = '';
      adminCrmCategories.detailData.visible_from = '';
      adminCrmCategories.detailData.visible_to = '';

      $('#meta_tag_title_feedback').remove();
      $('#meta_tag_description_feedback').remove();
     // $('#meta_tag_keyword_feedback').remove();


      $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(9.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
      $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(4.7%); height: 5px;background: #FF0000;position: relative;bottom: -105px;left: 13px;"></div>')
     // $('#meta_tag_keyword').before('<div id="meta_tag_keyword_feedback" style="width: calc(9.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')

     // this.detailData = {};
      this.checkInsert = true;
      this.titleDetail = this.newCategories;
      this.rowIdSelected = 0;
      $("#tabDetail").addClass("active");
      $("#tabTable").removeClass("active");
      spinnerHelpers.hide();
    },

    confirmSaveCategories() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSaveCategoriesSave();
      }
    },

    executeSaveCategoriesSave() {
      spinnerHelpers.show();
      var adminCrmCategories = this;
      this.rowsSelected = 0;
      this.tableResult = [];

      $.each(this.$refs.tableCategories.getRowSelected(), function(i, row) {
        var rowToSave = row;
        rowToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();
        adminCrmCategories.rowsSelected = adminCrmCategories.rowsSelected + 1;
       // rowToSave.idlanguage=adminCrmCategories.languages;

        categoriesServices.update(
          rowToSave,
          function() {
            adminCrmCategories.checkAllIsSaved();
            adminCrmCategories.tableResult.push({
              id: rowToSave.id,
              success: true
            });
            notificationHelpers.success(adminCrmCategories.updateCompleted);
          },
          function(response) {
            adminCrmCategories.checkAllIsSaved();
            adminCrmCategories.tableResult.push({
              id: rowToSave.id,
              success: false,
              message: response
            });
            notificationHelpers.error(response);
          }
        );
      });
    },

    confirmDeleteCategories() {
      if (confirm("Sei sicuro di voler eliminare?")) {
        this.executeDeleteCategories();
      }
    },
    executeDeleteCategories() {
      spinnerHelpers.show();
      var adminCrmCategories = this;
      this.rowsSelected = 0;
      this.tableResult = [];

      $.each(this.$refs.tableCategories.getRowSelected(), function(i, row) {
        adminCrmCategories.rowsSelected = adminCrmCategories.rowsSelected + 1;

        categoriesServices.del(
          row.id,
          function() {
            adminCrmCategories.checkAllIsSaved();
            notificationHelpers.success(adminCrmCategories.deleteCompleted);
            
          },
          function(response) {
            adminCrmCategories.checkAllIsSaved();
            adminCrmCategories.tableResult.push({
              id: rowToSave.id,
              success: false,
              message: response
            });
            notificationHelpers.error(response);
          }
        );
      });
    },

    onTableCheckCategories() {
      var countRowSelected = this.$refs.tableCategories.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
      } else {
        this.disableButton = false;
      }
    },

    confirmCancelNewCategories() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmCancel"))) {
        this.executeCancelCategories();
      }
    },

    executeCancelCategories() {
      this.loadTable();
      spinnerHelpers.show();
      this.detailTemplateEditorData = {};
      $("#tabTable").addClass("active");
      $("#tabDetail").removeClass("active");
      $('#tabDetailAttributeImages').removeClass("active");
      $('#tabAdminCategoriesGeneral').addClass("active");
      $('#tabDetailAttributeCategories').removeClass("active");
      $('#tabAdminCategoriesTranslate').removeClass("active");
      spinnerHelpers.hide();
    },

    confirmSaveNewCategories() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSaveNewCategories();
      }
    },

    executeSaveNewCategories() {
      spinnerHelpers.show();
      var adminCrmCategories = this;
      this.detailData.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

      if (!functionHelpers.isValued(this.detailData.code)) {
        this.detailData.code = false;
      }

      if (!functionHelpers.isValued(this.detailData.description)) {
        this.detailData.description = false;
      }

      if (!functionHelpers.isValued(this.languages)) {
        this.detailData.idLanguage = storageData.sIdLanguage();
      } else {
        this.detailData.idLanguage = this.languages;
      }

      if (
        functionHelpers.isValued(this.rowIdSelected) &&
        this.rowIdSelected > 0
      ) {
        this.detailData.id = this.rowIdSelected;

        categoriesServices.update(this.detailData, function(result) {
          adminCrmCategories.tableResult.push({
            id: result.data,
            success: true,
            message: adminCrmCategories.updateCompleted
          });
          notificationHelpers.success(adminCrmCategories.updateCompleted);
          adminCrmCategories.loadTable(adminCrmCategories.languages);
          $("#tabTable").addClass("active");
          $("#tabDetail").removeClass("active");
          
        });
      } else {
        
        categoriesServices.insert(this.detailData, function(result) {
          adminCrmCategories.tableResult.push({
            id: result.data,
            success: true,
            message: adminCrmCategories.insertCompleted
          });
          notificationHelpers.success(adminCrmCategories.insertCompleted);
          
          if(adminCrmCategories.checkInsert){
            spinnerHelpers.hide();
            adminCrmCategories.checkInsert = false;
            adminCrmCategories.rowIdSelected = result.data;
          }else{
            adminCrmCategories.loadTable(adminCrmCategories.languages);
            $("#tabTable").addClass("active");
            $("#tabDetail").removeClass("active");
          }
          
        });
      }
    },
    changeTitleTranlation(field, value) {
      var adminPages = this;
      var titleToUrl = $("#frmadminCrmItemsTranslation #description").val(),
        cleanUrl = "";
      cleanUrl =
        "/" +
        titleToUrl
          .replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&\s])/g, "-")
          .toLowerCase();
      if (
        adminPages.pageValueSelected.id == null ||
        $("#frmadminCrmItemsTranslation #link").val() == ""
      ) {
        $("#frmadminCrmItemsTranslation  #link").val(cleanUrl);
        adminPages.detailData.link = dataHelpers.unbind(cleanUrl);
      }
      this.checkUrl(cleanUrl);
    },
    checkUrlTranslation(url) {
      if (url == "link") {
        url = $("#frmadminCrmItemsTranslation #" + url).val();
      }
      var adminPages = this;

      if (adminPages.rowIdSelected == null) {
        pageServices.checkExistUrl(url, function(result) {
          if (result.data) {
            validationHelpers.setDetailError(
              "link",
              dictionaryHelpers.getDictionary("UrlAlreadyExist")
            );
          } else {
            $("#frmadminCrmItemsTranslation #link").removeClass("error");
            validationHelpers.clear("#frmadminCrmCategories");
          }
        });
      } else {
        pageServices.checkExistUrlNotForThisPage(
          url,
          adminPages.rowIdSelected,
          function(result) {
            if (result.data) {
              validationHelpers.setDetailError(
                "link",
                dictionaryHelpers.getDictionary("UrlAlreadyExist")
              );
            } else {
              $("#frmadminCrmItemsTranslation #link").removeClass("error");
              validationHelpers.clear("#frmadminCrmCategories");
            }
          }
        );
      }
    },
    changeTitle(field, value) {
      var adminPages = this;
      var titleToUrl = $("#description").val(),
        cleanUrl = "";
      cleanUrl =
        "/" +
        titleToUrl
          .replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&\s])/g, "-")
          .toLowerCase();
      if (
        adminPages.pageValueSelected.id == null ||
        $("#link").val() == ""
      ) {
        $("#link").val(cleanUrl);
        adminPages.detailData.link = dataHelpers.unbind(cleanUrl);
      }
      this.checkUrl(cleanUrl);
    },
    checkUrl(url) {
      if (url == "link") {
        url = $("#" + url).val();
      }
      var adminPages = this;

      if (adminPages.rowIdSelected == null) {
        pageServices.checkExistUrl(url, function(result) {
          if (result.data) {
            validationHelpers.setDetailError(
              "link",
              dictionaryHelpers.getDictionary("UrlAlreadyExist")
            );
          } else {
            $("#link").removeClass("error");
            validationHelpers.clear("#frmadminCrmCategories");
          }
        });
      } else {
        pageServices.checkExistUrlNotForThisPage(
          url,
          adminPages.rowIdSelected,
          function(result) {
            if (result.data) {
              validationHelpers.setDetailError(
                "link",
                dictionaryHelpers.getDictionary("UrlAlreadyExist")
              );
            } else {
              $("#link").removeClass("error");
              validationHelpers.clear("#frmadminCrmCategories");
            }
          }
        );
      }
    },
    checkAllIsSaved() {
      this.rowsSelected = this.rowsSelected - 1;
      if (this.rowsSelected == 0) {
        this.disableButton = true;
        this.loadTable(this.languages);
      }
    },
    onChangeCheckOnlineCategories(){
      var adminCrmItems = this;
      var data = {
        idCategories: adminCrmItems.rowIdSelected,
      };
      categoriesServices.updateOnlineCategories(data, function (result) {
        notificationHelpers.success("Aggiornamento avvenuto correttamente");
      });
    },
    updateOnlineCategories(id){
      var adminCrmItems = this;
      var data = {
        idCategories: id,
      };
      categoriesServices.updateOnlineCategories(data, function (result) {
        notificationHelpers.success("Aggiornamento avvenuto correttamente");
      });
    },
    /* CATEGORIES */
    loadListCategories() {
      spinnerHelpers.show();
      var ln = storageData.sIdLanguage();
      var adminCrmItems = this;
      if (!functionHelpers.isValued(ln)) {
        ln = storageData.sIdLanguage();
      }

      categoriesServices.getAllListNavigationFather(
        ln,
        adminCrmItems.rowIdSelected,
        function (result) {
          adminCrmItems.listTreeCategories = result.data;
          spinnerHelpers.hide();
        }
      );
    },
    checkCategoriesClick(id, checkedCategories) {
      var adminCrmItems = this;

      var data = {
        idCategories: id,
        idCategoriesSelected: adminCrmItems.rowIdSelected,
      };

      if (checkedCategories) {
        categoriesServices.insertCategoriesFather(data, function (result) {
          adminCrmItems.loadDetailListCategories();
          notificationHelpers.success("Categoria associata correttamente");
        });
      } else {
        categoriesServices.deleteCategoriesFather(id,adminCrmItems.rowIdSelected,function (result) {
          adminCrmItems.loadDetailListCategories();
          notificationHelpers.success("Categoria rimossa correttamente");
        });
      }
    },

    loadDetailListCategories() {
      var ln = storageData.sIdLanguage();
      var adminCrmItems = this;
      if (!functionHelpers.isValued(ln)) {
        ln = storageData.sIdLanguage();
      }
      categoriesServices.getAllDetailListCategoriesFather(ln,adminCrmItems.rowIdSelected,function (result) {
        adminCrmItems.arrayListCategoriesDetail = result.data;
      });
    },

    updateOrderCategoryItem(id) {
      var adminCrmItems = this;
      var data = {
        idCategories: adminCrmItems.rowIdSelected,
        idCategoriesFather: id,
        order: $("#inputOrder" + id).val(),
      };

      categoriesServices.updateOrderCategoryFather(data, function (result) {
        adminCrmItems.loadDetailListCategories();
        notificationHelpers.success("Ordinamento aggiornato");
      });
    },
    /* END CATEGORIES */
    /* IMMAGINI */
    loadItemImages() {
      var adminCrmItems = this;
      categoriesServices.getImages(adminCrmItems.rowIdSelected, function (result) {
        adminCrmItems.itemImages = result.data;
        if(!adminCrmItems.scriptGallery){
          $.getScript("https://cdn.rawgit.com/sachinchoolur/lightgallery.js/master/dist/js/lightgallery.js").done(function(){
            adminCrmItems.scriptGallery = true;
            $.getScript("https://cdn.jsdelivr.net/picturefill/2.3.1/picturefill.min.js");
            $.getScript("https://cdn.rawgit.com/sachinchoolur/lg-share.js/master/dist/lg-share.js");
            $.getScript("https://cdn.rawgit.com/sachinchoolur/lg-pager.js/master/dist/lg-pager.js");
            $.getScript("https://cdn.rawgit.com/sachinchoolur/lg-autoplay.js/master/dist/lg-autoplay.js");
            $.getScript("https://cdn.rawgit.com/sachinchoolur/lg-fullscreen.js/master/dist/lg-fullscreen.js");
            $.getScript("https://cdn.rawgit.com/sachinchoolur/lg-zoom.js/master/dist/lg-zoom.js");
            $.getScript("https://cdn.rawgit.com/sachinchoolur/lg-hash.js/master/dist/lg-hash.js");
            /*lightGallery(document.getElementById('lightgallery'));*/
            lightGallery(document.getElementById('tabDetailAttributeImages'), {
              selector : '.img'
            }); 
          });
        }
      });
    },
    deleteImage(isPrincipalImage, id) {
      var adminCrmItems = this;
      if (
        confirm("Sei sicuro di voler eliminare l'associazione dell'immagine?")
      ) {
        if (isPrincipalImage) {
          //update imgName = '' in items.imgName by id
          var data = {
            idItem: adminCrmItems.rowIdSelected,
            imgName: "",
            imgBase64: "",
          };

          categoriesServices.updateImageName(data, function (result) {
            adminCrmItems.loadItemImages();
            notificationHelpers.success("Eliminazione avvenuta correttamente");
          });
        }
      }
    },
    onChangeImageBanner(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImagePrincipalCategories(e.target.id, files[0].name, files[0], false);    
    },
    onChangeImagePrincipalCategories(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImagePrincipalCategories(e.target.id, files[0].name, files[0], true);
    },
    createImagePrincipalCategories(id, name, file, isPrincipal) {
      var adminCrmItems = this;
      var reader = new FileReader();
      var vm = this;

      reader.onload = (e) => {
        /*adminCrmItems.itemImages.img = e.target.result;
        adminCrmItems.itemImages.imgName = name;*/
        var data = {
          idItem: adminCrmItems.rowIdSelected,
          imgName: name,
          imgBase64: e.target.result,
          principal: isPrincipal
        };

        categoriesServices.updateImageName(data, function (result) {
          adminCrmItems.loadItemImages();
          notificationHelpers.success(
            "Immagine principale inserita con successo"
          );
        });
      };

      reader.readAsDataURL(file);
    },
    selectImageExist(id, isPrincipal) {
      var adminCrmItems = this;
      
      adminCrmItems.idImageSelectedToReplaceImage = id;
      adminCrmItems.selectedChangePrincipalImage = isPrincipal;
      var data = {
        page : adminCrmItems.pageImage,
        search : $('#modalImgBlogForm #search').val(),
        month : $('#modalImgBlogForm #month').val(),
        year : $('#modalImgBlogForm #year').val(),
      };
      //categoriesServices.getAllImagesInFolder(id, function (result) {
      pageServices.getByFile(data, function (result) {
        /*$('#ul-image').css('max-height', window.innerHeight - 200);
        adminCrmItems.arrayAllImagesExistFolder = result.data;*/
        $("#modalImageExistFolder").modal("show");
        if(result.data.length>0){
          if(adminCrmItems.arrayAllImagesExistFolder.length == 0 || adminCrmItems.pageImage == 1){
            
            adminCrmItems.arrayAllImagesExistFolder = result.data;
            $('#ul-image').css('max-height', window.innerHeight - 200);
          }else{
            var array1 = adminCrmItems.arrayAllImagesExistFolder;
            var array2 = result.data;
            var newArray = array1.concat(array2);
            adminCrmItems.arrayAllImagesExistFolder = newArray;
          }
        }
      });
    },
    selectReplaceImageExist(id, img) {
      var adminCrmItems = this;
      var data = {
        idItem: adminCrmItems.rowIdSelected,
        imgName: img,
        imgBase64: "",
        principal: adminCrmItems.selectedChangePrincipalImage
      };

      categoriesServices.updateImageName(data, function (result) {
        $("#modalImageExistFolder").modal("hide");
        adminCrmItems.loadItemImages();
        notificationHelpers.success(
          "Immagine principale aggiornata con successo"
        );
      });
    },
    /* END IMMAGINI */
    /* TRANSLATION */
    loadTranslation() {
      var adminCrmItems = this;
      categoriesServices.getCategoriesLanguages(adminCrmItems.rowIdSelected, function (result) {
        adminCrmItems.categoriesLanguages = result.data.selectItemExist;
        if(result.data.totalLn == result.data.totalLnCategoriesPresent){
          adminCrmItems.noMoreTranslate = true;
        }else{
          adminCrmItems.noMoreTranslate = false;
        }
      });
    },
    confirmSaveNewTranslate() {
      $("#modalExecuteTranslateItem").modal("show");
      var adminCrmItems = this;
      var ln = adminCrmItems.languages;
      if (!functionHelpers.isValued(ln)) {
        ln = storageData.sIdLanguage();
      }
      adminCrmItems.resultTranslatePopups.id = "";
      adminCrmItems.resultTranslatePopups.idItem = adminCrmItems.rowIdSelected;
      adminCrmItems.resultTranslatePopups.language_id = ln;
      adminCrmItems.resultTranslatePopups.description = "";
      adminCrmItems.resultTranslatePopups.link = "";
      adminCrmItems.resultTranslatePopups.meta_tag_characteristic = "";
      var searchParam = "";
      var initials = [];
      
      $("#language_id").select2({
        ajax: {
          url: configData.wsRootServicesUrl + "/api/v1/language/selectlanguagescategoriestranslate",
          data: function (params) {
            if (params.term == "") {
              searchParam = "*";
            } else {
              searchParam = params.term;
            }
            var query = {
              search: searchParam,
              idCategory: adminCrmItems.rowIdSelected
            };
            return query;
          },
          processResults: function (data) {
            var dataParse = JSON.parse(data);
            return {
              results: dataParse.data,
            };
          },
        },
      });
      


    },
    executeCopyDefaultTranslate(id, idItem, language_id) {
      var adminCrmItems = this;

      //se modifico riga esistente
      if (adminCrmItems.rowIdSelected != "") {
        categoriesServices.getByTranslateDefault(adminCrmItems.rowIdSelected, idItem, language_id, function (
          result
        ) {
          adminCrmItems.resultTranslatePopups = result.data[0];
        });
      } else {
        //se modifico riga aggiungi nuova traduzione
        categoriesServices.getByTranslateDefaultNew(idItem, language_id, function (
          result
        ) {
          adminCrmItems.resultTranslatePopups = result.data[0];
        });
      }
    },
    confirmSaveTranslate(id, idCategories, language_id, description, link, meta_tag_characteristic){
      
      if (functionHelpers.isValued(id)) {
        //spinnerHelpers.show();
        var adminCrmItems = this;
        var data = {};
        var data = {
          id: id,
          idCategories: idCategories,
          language_id: language_id,
          description: description,
          link: link,
          meta_tag_characteristic: meta_tag_characteristic,
        };
        categoriesServices.updateTranslate(data, function (result) {
          notificationHelpers.success("Traduzione modificata correttamente");
          $("#modalExecuteTranslateItem").modal("hide");
          adminCrmItems.loadTranslation();
        });
      } else {
        var adminCrmItems = this;
        var data = {};
        var data = {
          idCategories: adminCrmItems.rowIdSelected,
          language_id: language_id,
          description: description,
          link: link,
          meta_tag_characteristic: meta_tag_characteristic,
        };
        categoriesServices.insertTranslate(data, function (result) {
          notificationHelpers.success("Traduzione aggiunta con successo");
          $("#modalExecuteTranslateItem").modal("hide");
          adminCrmItems.loadTranslation();
        });
      }
    },
    executeOpenTranslationsLanguage(id) {
      var adminCrmItems = this;
      categoriesServices.getByTranslate(id, function (result) {
        adminCrmItems.resultTranslatePopups = result.data[0];
        $("#modalExecuteTranslateItem").modal("show");
      });

    },
    executeCancelTranslationsLanguage(id) {
      var adminCrmItems = this;
      if (confirm("Sei sicuro di voler eliminare la traduzione?"))
        categoriesServices.getCancelTranslate(id, function (result) {
          notificationHelpers.success("Eliminazione avvenuta correttamente");
          adminCrmItems.loadTranslation();
        });
    }
    /* END TRANSLATION */
  }
};
</script>
<style scoped>


@import url('https://cdn.rawgit.com/sachinchoolur/lightgallery.js/master/dist/css/lightgallery.css');

.card-title-admin .card{
  background: transparent;
  border:0px;
}
.card-title-admin h1{
  font-size:40px;
  font-weight: lighter;
  color:#303C54;
}

.align-btns {
 position: absolute;
    z-index: 1;
    margin-top: 10px;
}

.nav-tabs .nav-item{
  width:25%;
}
.nav-tabs .nav-link{
  width:100%;
  border-radius:0;
  color:#fff;
  background:#3c4b64;
  border-bottom:3px solid #f45f00 !important;
  border:0px;
}
.nav-tabs .nav-link.active{
  background:#2A3545 !important;
}
.nav-tabs>.nav-item>.nav-link:not(.active){
  background:#3c4b64  !important;
}
/* categories */

.listDetailCategories {
  padding: 10px 0px 10px 0px;
  border-bottom: 4px dashed #ededed;
}
.listDetailCategories:first-child {
  border-top: 4px dashed #ededed;
}
.listDetailCategories label {
  color: #303c54;
  font-size: 14px;
  font-weight: lighter;
}
.listDetailCategories h5 {
  font-size: 15px;
  font-weight: bold;
  color: #303c54;
}
/* end categories */

.div-row-img-item label {
  color: #303c54;
  font-size: 14px;
  font-weight: lighter;
}
.div-row-img-item {
  padding-top: 10px;
  padding-bottom: 10px;
}
.div-row-img-item img {
  max-height: 50px;
}
.label-name {
  margin-left: 10px;
}
.div-row-img-item .fa-trash {
  color: red;
  float: right;
  margin-top: 5px;
  margin-right: 5px;
}
.fa-trash {
  color: red;
}
.trashtable {
   color: #fff!important;
}

.div-row-img-item .form-control {
  float: left;
  width: 85%;
}
/* style for upload area */
#imgPrincipalCategories[type="file"] {
  display: none;
}
#imgBanner[type="file"] {
  display: none;
}
.custom-file-upload {
  padding: 20px;
  cursor: pointer;
  width: 100%;
  text-align: center;
  border: 3px dashed #ededed;
  border-radius: 10px;
}
/* end style for upload area */
.previewImageExistFolder {
  max-width: 100%;
  max-height: 150px;
}
.contPreviewImageExistFolder {
  padding: 15px;
  margin: 2px;
  border: 2px solid #ededed;
  cursor: pointer;
}

/* translate */
#tabAdminCategoriesTranslate label {
  font-size: 20px;
  font-weight: bold;
  color: #303c54;
  display: inline-block;
  margin-right: 25px;
}
.div-row-translation span {
  color: #303c54;
  font-size: 14px;
  font-weight: lighter;
}

.div-row-translation .translate-characteristic {
  max-height: 70px;
  overflow: auto;
}

/* end translate */

.bs-checkbox input{
  position: relative !important;
}

/* popup image */

#ul-image{
  width: 100%;
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  max-height: 50px;
  overflow:auto;
}
.listLi {
  list-style: none;
  text-align: center;
}
.list-group-item{
  margin-bottom: 5px;
  height: 105px;
  padding: 0px;
  background: #ededed;
  border-radius: 0px;
}
.labelListImage {
  cursor: pointer;
  font-size: 12px;
  padding: 2px;
  position: absolute;
  left: 0;
  top: 0px !important;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  background: rgba(255,255,255,0.7);
}
.div-extension-img{
    position: absolute;
    bottom: 0px;
    left: 0px;
    background: #238AE6;
    border-radius: 5px;
    padding-left: 5px;
    padding-right: 5px;
    box-shadow: 0px 0px 7px -2px rgb(0 0 0 / 30%);
}

.div-extension-img label {
    font-size: 10px;
    margin: 0px !important;
    display: block;
    color: #fff;
    font-weight: bold;
}
/* end popup image */


</style>
